export const stringWithoutCaracteres = (value: any): string | null => {
  if (!value) {
    return null;
  }
  return value.replace(/[^a-zA-Z0-9]/g, "");
};
